import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const parseActivationUrl = (url) => {
  const regex = /user\/activate\?value=([^&]+)/i;
  const match = url?.match(regex);
  return match ? match[1] : null;
};

export const useActivationLink = () => {
  const deepLinkUrl = useSelector((state) => state.auth.url);
  const [activationValue, setActivationValue] = useState(null);

  useLayoutEffect(() => {
    if (deepLinkUrl) {
      const value = parseActivationUrl(deepLinkUrl);
      if (value) {
        setActivationValue(value);
      }
    }
  }, [deepLinkUrl]);

  return activationValue;
};
